(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bidder-registration"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const API = 'https://luxur-auction-api.luxurfineart.workers.dev';
    const root = document.currentScript?.closest('.shopify-section')?.querySelector('.luxur-bidder-registration') || document.querySelector('.luxur-bidder-registration');
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const form = root.querySelector('[data-registration-form]');
    const notice = root.querySelector('[data-registration-notice]');
    const button = root.querySelector('[type="submit"]');

    const showNotice = (message, type) => {
      notice.textContent = message;
      notice.dataset.type = type;
      notice.hidden = false;
      notice.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };

    const params = new URLSearchParams(window.location.search);
    if (params.get('registration') === 'cancelled') {
      showNotice('Card verification was cancelled. Your registration has not been approved. You may continue when ready.', 'error');
    }

    if (params.get('registration') === 'success' && params.get('session_id')) {
      form.hidden = true;
      showNotice('Confirming your secure card verification…', 'success');
      fetch(API + '/api/bidders/confirm', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ sessionId: params.get('session_id') })
      })
        .then(async response => {
          const data = await response.json();
          if (!response.ok) throw new Error(data.error || 'Unable to confirm card verification.');
          showNotice('Registration received. Your card has been verified and your bidder account is pending staff review. After approval, sign in with the email and password you created.', 'success');
          window.history.replaceState({}, '', window.location.pathname);
        })
        .catch(error => {
          form.hidden = false;
          showNotice(error.message, 'error');
        });
    }

    form.addEventListener('submit', async event => {
      event.preventDefault();
      if (!form.reportValidity()) return;
      if (form.elements.password.value !== form.elements.confirmation.value) {
        showNotice('Passwords do not match.', 'error');
        form.elements.confirmation.focus();
        return;
      }
      button.disabled = true;
      button.textContent = 'Opening secure verification…';
      notice.hidden = true;
      const fields = new FormData(form);
      const payload = Object.fromEntries(fields.entries());
      payload.acceptTerms = fields.get('acceptTerms') === 'on';

      try {
        const response = await fetch(API + '/api/bidders/register', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
        const data = await response.json();
        if (!response.ok || !data.checkoutUrl) throw new Error(data.error || 'Unable to start card verification.');
        window.location.assign(data.checkoutUrl);
      } catch (error) {
        showNotice(error.message, 'error');
        button.disabled = false;
        button.textContent = 'Continue to secure card verification';
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxur-auction-catalog"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.luxur-auction').forEach(section => {
    const apiRoot = section.dataset.apiUrl.replace(/\/$/, '');
    const grid = section.querySelector('[data-auction-grid]');
    const meta = section.querySelector('[data-auction-meta]');
    const status = section.querySelector('[data-auction-status]');
    const accountBar = section.querySelector('[data-account-bar]');
    const more = section.querySelector('[data-load-more]');
    const searchInput = section.querySelector('[data-catalog-search]');
    const sortSelect = section.querySelector('[data-catalog-sort]');
    const resultsCount = section.querySelector('[data-results-count]');
    const lotDialog = section.querySelector('[data-lot-dialog]');
    const detail = section.querySelector('[data-lot-detail]');
    const authDialog = section.querySelector('[data-auth-dialog]');
    const authView = section.querySelector('[data-auth-view]');
    const labels = section.dataset;
    const tokenKey = 'luxur_bidder_session';
    let token = localStorage.getItem(tokenKey) || '';
    let bidder = null;
    let auctionId;
    let offset = 0;
    const limit = 24;
    const money = value => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(value || 0);
    const escapeHtml = value => String(value ?? '').replace(/[&<>'"]/g, character => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[character]);
    const request = async (path, options = {}) => {
      const response = await fetch(apiRoot + path, { ...options, headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: 'Bearer ' + token } : {}), ...options.headers } });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(data.error || labels.error);
      return data;
    };
    const renderAccount = () => {
      if (!bidder) {
        accountBar.innerHTML = '<p>Sign in to your approved bidder account.</p><div><button type="button" data-action-sign-in>' + labels.signIn + '</button> <a class="secondary" href="/pages/bidder-registration">' + labels.register + '</a></div>';
      } else {
        const state = bidder.canBid ? 'Approved to bid' : labels.pendingApproval;
        accountBar.innerHTML = '<p><strong>' + escapeHtml(bidder.firstName + ' ' + bidder.lastName) + '</strong> · ' + escapeHtml(state) + '</p><div><button type="button" class="secondary" data-action-my-bids>' + labels.myBids + '</button> <button type="button" class="secondary" data-action-sign-out>' + labels.signOut + '</button></div>';
      }
    };
    const openLogin = message => {
      authView.innerHTML = '<h2 id="luxur-auth-title">' + labels.signIn + '</h2>' + (message ? '<p class="luxur-auth-message">' + escapeHtml(message) + '</p>' : '') + '<form class="luxur-auth-form" data-login><label>Email<input type="email" name="email" autocomplete="email" required></label><label>Password<input type="password" name="password" autocomplete="current-password" required></label><button type="submit">' + labels.signIn + '</button><a href="/pages/bidder-registration">' + labels.register + '</a></form>';
      authDialog.showModal();
      authView.querySelector('[data-login]').onsubmit = async event => {
        event.preventDefault();
        const values = Object.fromEntries(new FormData(event.currentTarget));
        try { const data = await request('/api/bidders/login', { method: 'POST', body: JSON.stringify(values) }); token = data.token; localStorage.setItem(tokenKey, token); bidder = data.bidder; authDialog.close(); renderAccount(); }
        catch (error) { openLogin(error.message); }
      };
    };
    const openActivation = activationToken => {
      authView.innerHTML = '<h2 id="luxur-auth-title">Activate bidder account</h2><p>Set a password for your approved bidder account.</p><form class="luxur-auth-form" data-activate><label>Password<input type="password" name="password" minlength="8" autocomplete="new-password" required></label><label>Confirm password<input type="password" name="confirmation" minlength="8" autocomplete="new-password" required></label><button type="submit">Activate account</button></form>';
      authDialog.showModal();
      authView.querySelector('[data-activate]').onsubmit = async event => {
        event.preventDefault(); const values = Object.fromEntries(new FormData(event.currentTarget)); values.token = activationToken;
        try { await request('/api/bidders/activate', { method: 'POST', body: JSON.stringify(values) }); history.replaceState({}, '', location.pathname + '#luxur-online-auction'); openLogin('Account activated. Sign in to continue.'); }
        catch (error) { authView.insertAdjacentHTML('afterbegin', '<p class="luxur-auth-message">' + escapeHtml(error.message) + '</p>'); }
      };
    };
    const loadMe = async () => {
      if (!token) { renderAccount(); return; }
      try { bidder = (await request('/api/bidders/me')).bidder; } catch (_) { token = ''; localStorage.removeItem(tokenKey); bidder = null; }
      renderAccount();
    };
    const lotUrl = id => window.location.pathname + '?lot=' + encodeURIComponent(id) + '#luxur-online-auction';
    const renderCard = lot => '<a class="luxur-lot" href="' + lotUrl(lot.id) + '" data-lot-id="' + lot.id + '"><div class="luxur-lot__image"><img src="' + escapeHtml(lot.image_url) + '" alt="' + escapeHtml(lot.title) + '" loading="lazy" width="600" height="600"></div><p class="luxur-lot__number">LOT ' + escapeHtml(lot.lot_number) + '</p><h3>' + escapeHtml(lot.title) + '</h3><p class="luxur-lot__estimate">' + labels.estimate + ': ' + money(lot.estimate_low) + '–' + money(lot.estimate_high) + '</p><p class="luxur-lot__price">' + (lot.current_bid > 0 ? labels.currentBid : labels.startingBid) + ': ' + money(lot.current_bid || lot.start_price) + '</p><span class="luxur-lot__view">' + labels.viewLot + ' & bid</span></a>';
    const loadLots = async () => { const query = encodeURIComponent(searchInput.value.trim()); const sort = encodeURIComponent(sortSelect.value); const data = await request('/api/auctions/' + auctionId + '/lots?limit=' + limit + '&offset=' + offset + '&q=' + query + '&sort=' + sort); if (offset === 0) grid.innerHTML = ''; grid.insertAdjacentHTML('beforeend', data.lots.map(renderCard).join('')); offset += data.lots.length; resultsCount.textContent = data.total + ' lots'; more.hidden = offset >= data.total; if (data.total === 0) grid.innerHTML = '<p>' + labels.noLots + '</p>'; };
    const openLot = async id => {
      lotDialog.showModal(); detail.innerHTML = '<p style="padding:48px">' + labels.loading + '</p>';
      try {
        const lot = (await request('/api/lots/' + id)).lot;
        let myMax = { maxAmount: null, isLeading: false, outbid: false };
        if (bidder?.canBid) {
          try { myMax = await request('/api/lots/' + id + '/my-max-bid'); } catch (_) {}
        }
        const images = lot.images || [];
        const mainImage = images[0]?.source_url || '';
        const itemDescription = String(lot.description || '').split(/\s+Shipping:/i)[0].trim();
        const description = escapeHtml(itemDescription || labels.noDescription).replace(/\n/g, '<br>');
        const condition = escapeHtml(lot.condition_report || labels.conditionRequest).replace(/\n/g, '<br>');
        const shipping = escapeHtml(labels.shippingCopy).replace(/\n/g, '<br>');
        const payment = escapeHtml(labels.paymentCopy).replace(/\n/g, '<br>');
        const auctionDate = new Intl.DateTimeFormat('en-US', { dateStyle: 'long', timeStyle: 'short', timeZone: 'America/New_York' }).format(new Date(lot.starts_at)) + ' ET';
        const bidCount = Number(lot.bid_count || 0);
        const priceLabel = lot.current_bid > 0 ? labels.currentBid + ' (' + bidCount + ' ' + (bidCount === 1 ? labels.bidLabel : labels.bidsLabel) + ')' : labels.startingBid;
        let action = '<div class="luxur-detail__locked"><strong>' + labels.signIn + '</strong><br>' + labels.locked + '<br><button type="button" class="secondary" data-lot-sign-in>' + labels.signIn + '</button> <a href="/pages/bidder-registration">' + labels.register + '</a></div>';
        if (bidder && !bidder.canBid) action = '<p class="luxur-detail__locked">' + labels.pendingApproval + '</p>';
        if (bidder?.canBid && lot.auction_status === 'prebid') {
          const suggestions = lot.suggested_bids || [lot.next_bid];
          const bidNames = [labels.goodBid, labels.strongBid, labels.competitiveBid];
          const options = suggestions.map((amount, index) => '<option value="' + amount + '">' + escapeHtml(bidNames[index] || labels.nextBid) + ' — ' + money(amount) + '</option>').join('');
          let bidderState = '';
          if (myMax.outbid) bidderState = '<div class="luxur-max-bid__state luxur-max-bid__state--outbid"><strong>' + labels.outbid + '</strong>' + labels.outbidCopy + '<br>' + labels.yourMax + ': ' + money(myMax.maxAmount) + '</div>';
          else if (myMax.isLeading) bidderState = '<div class="luxur-max-bid__state"><strong>' + labels.leading + '</strong>' + labels.yourMax + ': ' + money(myMax.maxAmount) + '</div>';
          action = '<div class="luxur-max-bid">' + bidderState + '<p class="luxur-max-bid__title">' + labels.setMaxBid + '</p><label><span>' + labels.nextBid + '</span><select data-max-suggestion>' + options + '</select></label><label><span>' + labels.higherMax + '</span><input type="number" inputmode="numeric" min="' + lot.next_bid + '" step="1" placeholder="' + money(lot.next_bid) + '" data-custom-max></label><button type="button" data-place-max-bid="' + lot.id + '">' + labels.placeBid + '</button><p data-bid-message aria-live="polite"></p><p class="luxur-max-bid__approved">' + labels.approved + '</p></div>';
        } else if (bidder?.canBid) {
          action = '<div class="luxur-detail__actions"><button type="button" data-place-bid="' + lot.id + '" data-amount="' + lot.next_bid + '">' + labels.placeBid + ' ' + money(lot.next_bid) + '</button><p data-bid-message aria-live="polite"></p></div>';
        }
        const thumbs = images.map((image, index) => '<button type="button" class="luxur-detail__thumb" data-image="' + escapeHtml(image.source_url) + '" aria-label="View image ' + (index + 1) + '" aria-current="' + (index === 0 ? 'true' : 'false') + '"><img src="' + escapeHtml(image.source_url) + '" alt="" width="160" height="160"></button>').join('');
        const galleryNav = '<nav class="luxur-detail__nav" aria-label="Lot navigation">' + (lot.previous_lot_id ? '<button type="button" data-open-lot="' + lot.previous_lot_id + '">← ' + labels.previousLot + '</button>' : '<span class="luxur-detail__nav-spacer"></span>') + (lot.next_lot_id ? '<button type="button" data-open-lot="' + lot.next_lot_id + '">' + labels.nextLotLabel + ' →</button>' : '') + '</nav>';
        detail.innerHTML = '<article class="luxur-detail"><div class="luxur-detail__gallery">' + galleryNav + '<div class="luxur-detail__main"><img data-main-image src="' + escapeHtml(mainImage) + '" alt="' + escapeHtml(lot.title) + '" width="1000" height="1000"></div><div class="luxur-detail__thumbs" aria-label="Lot images">' + thumbs + '</div></div><div class="luxur-detail__side"><p class="luxur-detail__auction">' + escapeHtml(lot.auction_title) + '</p><p class="luxur-lot__number">LOT ' + escapeHtml(lot.lot_number) + '</p><h2 id="luxur-lot-title">' + escapeHtml(lot.title) + '</h2><p class="luxur-detail__estimate">' + labels.estimate + ': ' + money(lot.estimate_low) + '–' + money(lot.estimate_high) + '</p><div class="luxur-detail__sale"><span>' + priceLabel + '</span><strong>' + money(lot.current_bid || lot.start_price) + '</strong></div><div class="luxur-detail__next"><span>' + labels.nextBid + '</span><strong>' + money(lot.next_bid) + '</strong></div>' + action + '<p class="luxur-detail__trust">' + labels.secureBidding + '</p><div class="luxur-detail__facts"><details open><summary>' + labels.itemDetails + '</summary><p>' + description + '</p></details><details><summary>' + labels.condition + '</summary><div class="luxur-detail__policy">' + condition + '</div></details><details><summary>' + labels.shippingPickup + '</summary><div class="luxur-detail__policy">' + shipping + '</div></details><details><summary>' + labels.paymentTerms + '</summary><div class="luxur-detail__policy">' + payment + '</div></details></div><a class="luxur-detail__question" href="mailto:luxurfineart@gmail.com?subject=' + encodeURIComponent('Question about lot ' + lot.lot_number) + '">' + labels.askQuestion + '</a><p class="luxur-detail__auction">' + labels.auctionStarts + ': ' + auctionDate + '</p></div></article>';
        detail.querySelectorAll('[data-image]').forEach(button => button.onclick = () => { detail.querySelector('[data-main-image]').src = button.dataset.image; detail.querySelectorAll('[data-image]').forEach(item => item.setAttribute('aria-current', String(item === button))); });
        detail.querySelectorAll('[data-open-lot]').forEach(button => button.onclick = () => { const nextId = button.dataset.openLot; history.replaceState({}, '', lotUrl(nextId)); openLot(nextId); });
        const loginButton = detail.querySelector('[data-lot-sign-in]'); if (loginButton) loginButton.onclick = () => openLogin();
        const bidButton = detail.querySelector('[data-place-bid]');
        if (bidButton) bidButton.onclick = async () => { if (!confirm('Place bid of ' + money(Number(bidButton.dataset.amount)) + '?')) return; bidButton.disabled = true; try { const result = await request('/api/lots/' + id + '/bids', { method: 'POST', body: JSON.stringify({ amount: Number(bidButton.dataset.amount) }) }); detail.querySelector('[data-bid-message]').textContent = result.status === 'accepted' ? labels.bidAccepted : labels.bidPending; if (result.status === 'accepted') setTimeout(() => openLot(id), 900); } catch (error) { detail.querySelector('[data-bid-message]').textContent = error.message; bidButton.disabled = false; } };
        const maxBidButton = detail.querySelector('[data-place-max-bid]');
        if (maxBidButton) maxBidButton.onclick = async () => {
          const custom = Number(detail.querySelector('[data-custom-max]').value);
          const suggested = Number(detail.querySelector('[data-max-suggestion]').value);
          const maxAmount = custom || suggested;
          if (!Number.isSafeInteger(maxAmount) || maxAmount < Number(lot.next_bid)) { detail.querySelector('[data-bid-message]').textContent = 'Enter a maximum bid of at least ' + money(lot.next_bid) + '.'; return; }
          if (!confirm('Place maximum bid of ' + money(maxAmount) + '?')) return;
          maxBidButton.disabled = true;
          try { const result = await request('/api/lots/' + id + '/bids', { method: 'POST', body: JSON.stringify({ maxAmount }) }); detail.querySelector('[data-bid-message]').textContent = result.isLeading ? labels.bidAccepted : labels.outbid; setTimeout(() => openLot(id), 900); }
          catch (error) { detail.querySelector('[data-bid-message]').textContent = error.message; maxBidButton.disabled = false; }
        };
      } catch (_) { detail.innerHTML = '<p style="padding:48px">' + labels.error + '</p>'; }
    };
    const openMyBids = async () => {
      authView.innerHTML = '<h2 id="luxur-auth-title">' + labels.myBids + '</h2><p>' + labels.loading + '</p>'; authDialog.showModal();
      try { const data = await request('/api/bidders/bids'); authView.innerHTML = '<h2 id="luxur-auth-title">' + labels.myBids + '</h2><ul class="luxur-bids">' + (data.bids.length ? data.bids.map(b => '<li><strong>Lot ' + escapeHtml(b.lot_number) + ' · ' + escapeHtml(b.title) + '</strong><br>' + money(b.amount) + ' · ' + escapeHtml(b.status) + (b.auction_status === 'prebid' && ['accepted','pending'].includes(b.status) ? '<br><button type="button" data-withdraw="' + b.id + '">Withdraw bid</button>' : '') + '</li>').join('') : '<li>No bids yet.</li>') + '</ul>'; authView.querySelectorAll('[data-withdraw]').forEach(button => button.onclick = async () => { if (!confirm('Withdraw this bid?')) return; await request('/api/bids/' + button.dataset.withdraw + '/withdraw', { method: 'POST', body: '{}' }); openMyBids(); }); }
      catch (error) { authView.innerHTML = '<p class="luxur-auth-message">' + escapeHtml(error.message) + '</p>'; }
    };
    accountBar.addEventListener('click', async event => { if (event.target.closest('[data-action-sign-in]')) openLogin(); if (event.target.closest('[data-action-my-bids]')) openMyBids(); if (event.target.closest('[data-action-sign-out]')) { try { await request('/api/bidders/logout', { method: 'POST', body: '{}' }); } catch (_) {} token = ''; bidder = null; localStorage.removeItem(tokenKey); renderAccount(); } });
    grid.addEventListener('click', event => { const link = event.target.closest('[data-lot-id]'); if (!link) return; event.preventDefault(); history.replaceState({}, '', link.href); openLot(link.dataset.lotId); });
    more.addEventListener('click', () => loadLots().catch(() => { more.hidden = true; }));
    let searchTimer; searchInput.addEventListener('input', () => { clearTimeout(searchTimer); searchTimer = setTimeout(() => { offset = 0; loadLots().catch(() => { grid.innerHTML = '<p>' + labels.error + '</p>'; }); }, 280); });
    sortSelect.addEventListener('change', () => { offset = 0; loadLots().catch(() => { grid.innerHTML = '<p>' + labels.error + '</p>'; }); });
    section.querySelector('[data-close-dialog]').addEventListener('click', () => lotDialog.close());
    section.querySelector('[data-close-auth]').addEventListener('click', () => authDialog.close());
    lotDialog.addEventListener('click', event => { if (event.target === lotDialog) lotDialog.close(); }); authDialog.addEventListener('click', event => { if (event.target === authDialog) authDialog.close(); });
    loadMe();
    const activationToken = new URLSearchParams(location.search).get('activate'); if (activationToken) openActivation(activationToken);
    request('/api/auctions').then(data => { const auction = data.auctions?.[0]; if (!auction) throw new Error('auction'); auctionId = auction.id; meta.textContent = auction.title + ' · ' + new Intl.DateTimeFormat('en-US', { dateStyle: 'long', timeStyle: 'short', timeZone: 'America/New_York' }).format(new Date(auction.starts_at)) + ' ET'; status.textContent = auction.status === 'live' ? 'Live' : 'Pre-bidding open'; status.hidden = false; return loadLots(); }).then(() => { const requested = new URLSearchParams(location.search).get('lot'); if (requested) openLot(requested); }).catch(() => { grid.innerHTML = '<p>' + labels.error + '</p>'; });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxur-auction-preview"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-auction-demo]').forEach((demo) => {
    const tabs = demo.querySelectorAll('[data-auction-tab]');
    const panels = demo.querySelectorAll('[data-auction-panel]');
    const toast = demo.querySelector('[data-auction-toast]');
    const prices = demo.querySelectorAll('[data-current-bid]');
    const activity = demo.querySelector('[data-bid-activity]');
    const latestBid = demo.querySelector('[data-latest-bid]');
    const latestBidder = demo.querySelector('[data-latest-bidder]');
    const bidButton = demo.querySelector('[data-place-bid]');
    const withdrawButton = demo.querySelector('[data-withdraw-prebid]');
    const bidGuidance = demo.querySelector('[data-bid-guidance]');
    const pendingCard = demo.querySelector('[data-pending-card]');
    const noPending = demo.querySelector('[data-no-pending]');
    const pendingAmount = demo.querySelector('[data-pending-amount]');
    const pendingIndicator = demo.querySelector('[data-pending-indicator]');
    const phaseStatus = demo.querySelector('[data-phase-status]');
    const clerkPhase = demo.querySelector('[data-clerk-phase]');
    const clerkPhaseNote = demo.querySelector('[data-clerk-phase-note]');
    const latestStatus = demo.querySelector('[data-latest-status]');
    const automaticNote = demo.querySelector('[data-automatic-note]');
    const startTime = new Date(demo.dataset.auctionStart).getTime();
    const bidHistory = [1200, 1100, 1000];
    const undoStack = [];
    const customerPrebids = [];
    let amount = 1200;
    let pendingLiveBid = null;
    let previewPhase = Date.now() >= startTime ? 'live' : 'pre';

    const copy = {
      pre: demo.dataset.copyPre,
      live: demo.dataset.copyLive,
      preName: demo.dataset.copyPreName,
      liveName: demo.dataset.copyLiveName,
      preGuide: demo.dataset.copyPreGuide,
      liveGuide: demo.dataset.copyLiveGuide,
      preClerk: demo.dataset.copyPreClerk,
      liveClerk: demo.dataset.copyLiveClerk,
      acceptedPre: demo.dataset.copyAcceptedPre,
      acceptedLive: demo.dataset.copyAcceptedLive,
      preStaff: demo.dataset.copyPreStaff,
      liveStaff: demo.dataset.copyLiveStaff
    };

    const formatAmount = (value) => '$' + value.toLocaleString('en-US');

    const notify = (message) => {
      toast.textContent = message;
      window.clearTimeout(demo.auctionMessageTimer);
      demo.auctionMessageTimer = window.setTimeout(() => {
        toast.textContent = '';
      }, 5000);
    };

    const showAmount = () => {
      prices.forEach((price) => {
        price.textContent = formatAmount(amount);
      });
      if (latestBid) latestBid.textContent = formatAmount(amount);
    };

    const renderActivity = () => {
      if (!activity) return;
      activity.replaceChildren();
      bidHistory.forEach((bidAmount) => {
        const row = document.createElement('li');
        const bidder = document.createElement('span');
        const value = document.createElement('strong');
        bidder.textContent = activity.dataset.bidderLabel;
        value.textContent = formatAmount(bidAmount);
        row.append(bidder, value);
        activity.append(row);
      });
    };

    const setNextBid = () => {
      if (!bidButton) return;
      const nextAmount = amount + (amount < 2000 ? 100 : 250);
      bidButton.dataset.amount = String(nextAmount);
      const amountLabel = bidButton.querySelector('span');
      if (amountLabel) amountLabel.textContent = formatAmount(nextAmount);
    };

    const snapshot = () => ({
      amount,
      bids: [...bidHistory],
      bidder: latestBidder?.textContent || ''
    });

    const restore = (state) => {
      amount = state.amount;
      bidHistory.splice(0, bidHistory.length, ...state.bids);
      if (latestBidder) latestBidder.textContent = state.bidder;
      showAmount();
      renderActivity();
      setNextBid();
    };

    const applyBid = (newAmount, message, allowEqual, bidderName) => {
      if (!Number.isFinite(newAmount) || newAmount < amount || (!allowEqual && newAmount === amount)) return false;
      undoStack.push(snapshot());
      amount = newAmount;
      bidHistory.unshift(newAmount);
      bidHistory.splice(3);
      if (latestBidder && bidderName) latestBidder.textContent = bidderName;
      showAmount();
      renderActivity();
      setNextBid();
      notify(message);
      return true;
    };

    const renderPending = () => {
      const hasPending = Number.isFinite(pendingLiveBid);
      if (pendingCard) pendingCard.hidden = !hasPending;
      if (noPending) noPending.hidden = hasPending;
      if (pendingIndicator) pendingIndicator.textContent = hasPending ? '1' : '0';
      if (pendingAmount && hasPending) pendingAmount.textContent = formatAmount(pendingLiveBid);
    };

    const renderPhase = () => {
      const isLive = previewPhase === 'live';
      if (phaseStatus) phaseStatus.textContent = isLive ? copy.live : copy.pre;
      if (clerkPhase) clerkPhase.textContent = isLive ? copy.liveName : copy.preName;
      if (clerkPhaseNote) clerkPhaseNote.textContent = isLive ? copy.liveClerk : copy.preClerk;
      if (bidGuidance) bidGuidance.textContent = isLive ? copy.liveGuide : copy.preGuide;
      if (latestStatus) latestStatus.textContent = isLive ? copy.acceptedLive : copy.acceptedPre;
      if (automaticNote) automaticNote.textContent = isLive ? copy.liveStaff : copy.preStaff;
      if (withdrawButton) {
        withdrawButton.disabled = isLive || customerPrebids.length === 0;
        withdrawButton.hidden = isLive;
      }
      demo.querySelectorAll('[data-set-phase]').forEach((button) => {
        button.classList.toggle('is-active', button.dataset.setPhase === previewPhase);
      });
    };

    const updateCountdown = () => {
      const remaining = Math.max(0, startTime - Date.now());
      const totalSeconds = Math.floor(remaining / 1000);
      const values = {
        days: Math.floor(totalSeconds / 86400),
        hours: Math.floor(totalSeconds % 86400 / 3600),
        minutes: Math.floor(totalSeconds % 3600 / 60),
        seconds: totalSeconds % 60
      };
      Object.entries(values).forEach(([unit, value]) => {
        const element = demo.querySelector('[data-countdown-' + unit + ']');
        if (element) element.textContent = String(value).padStart(2, '0');
      });
      if (remaining === 0 && previewPhase !== 'live') {
        previewPhase = 'live';
        renderPhase();
      }
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        tabs.forEach((item) => {
          const selected = item === tab;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-selected', selected ? 'true' : 'false');
        });
        panels.forEach((panel) => {
          panel.hidden = panel.dataset.auctionPanel !== tab.dataset.auctionTab;
        });
        toast.textContent = '';
      });
    });

    const openRequestedView = () => {
      const requestedView = window.location.hash === '#clerk' ? 'clerk' : 'bidder';
      demo.querySelector('[data-auction-tab="' + requestedView + '"]')?.click();
    };

    openRequestedView();
    window.addEventListener('hashchange', openRequestedView);

    demo.querySelectorAll('[data-demo-action]').forEach((button) => {
      button.addEventListener('click', () => notify(button.dataset.message));
    });

    bidButton?.addEventListener('click', () => {
      const submittedAmount = Number(bidButton.dataset.amount);
      if (previewPhase === 'pre') {
        const beforeBid = snapshot();
        if (applyBid(submittedAmount, bidButton.dataset.prebidMessage, false, 'Bidder 1047')) {
          customerPrebids.push(beforeBid);
          renderPhase();
        }
      } else {
        pendingLiveBid = submittedAmount;
        renderPending();
        notify(bidButton.dataset.liveMessage);
      }
    });

    withdrawButton?.addEventListener('click', () => {
      if (previewPhase === 'live') {
        notify(withdrawButton.dataset.closedMessage);
        return;
      }
      const previous = customerPrebids.pop();
      if (!previous) {
        notify(withdrawButton.dataset.emptyMessage);
        return;
      }
      undoStack.pop();
      restore(previous);
      notify(withdrawButton.dataset.message);
      renderPhase();
    });

    demo.querySelector('[data-accept-live]')?.addEventListener('click', (event) => {
      if (!Number.isFinite(pendingLiveBid)) return;
      if (applyBid(pendingLiveBid, event.currentTarget.dataset.message, false, 'Bidder 1047')) {
        pendingLiveBid = null;
        renderPending();
      }
    });

    demo.querySelector('[data-decline-live]')?.addEventListener('click', (event) => {
      if (!Number.isFinite(pendingLiveBid)) return;
      pendingLiveBid = null;
      renderPending();
      notify(event.currentTarget.dataset.message);
    });

    demo.querySelectorAll('[data-set-phase]').forEach((button) => {
      button.addEventListener('click', () => {
        previewPhase = button.dataset.setPhase;
        if (previewPhase === 'pre') pendingLiveBid = null;
        renderPending();
        renderPhase();
      });
    });

    demo.querySelector('[data-competing-bid]')?.addEventListener('click', (event) => {
      const button = event.currentTarget;
      const enteredAmount = Number(demo.querySelector('[data-clerk-amount]')?.value);
      if (applyBid(enteredAmount, button.dataset.message, true, (demo.querySelector('[data-clerk-bidder]')?.value.trim() || 'Live bidder'))) {
        if (latestStatus) latestStatus.textContent = copy.acceptedLive;
      } else {
        notify(button.dataset.invalidMessage);
      }
    });

    demo.querySelector('[data-undo-bid]')?.addEventListener('click', (event) => {
      const button = event.currentTarget;
      const previous = undoStack.pop();
      if (!previous) {
        notify(button.dataset.emptyMessage);
        return;
      }
      restore(previous);
      if (customerPrebids.length) customerPrebids.pop();
      notify(button.dataset.message);
      renderPhase();
    });

    showAmount();
    renderActivity();
    setNextBid();
    renderPending();
    renderPhase();
    updateCountdown();
    window.setInterval(updateCountdown, 1000);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxur-gallery-home"] && !Shopify.designMode) return;
  try {
    
(() => {
const updateCountdown = () => document.querySelectorAll('[data-auction-start]').forEach(section => {
  const start = Date.parse(section.dataset.auctionStart);
  const target = section.querySelector('[data-auction-countdown]');
  if (!target || !Number.isFinite(start)) return;
  const days = Math.ceil((start - Date.now()) / 86400000);
  target.textContent = days > 1 ? days + ' ' + section.dataset.daysLeft : days === 1 ? '1 ' + section.dataset.dayLeft : section.dataset.auctionOpen;
});
const updateRegistration = async () => {
  const token = localStorage.getItem('luxur_bidder_session');
  const apiRoot = document.querySelector('.luxur-auction')?.dataset.apiUrl?.replace(/\/$/, '');
  if (!token || !apiRoot) return;
  try {
    const response = await fetch(apiRoot + '/api/bidders/me', { headers: { Authorization: 'Bearer ' + token } });
    const data = await response.json();
    if (!response.ok || !data.bidder?.canBid) return;
    document.querySelectorAll('[data-registration-approved]').forEach(item => { item.hidden = false; });
    document.querySelectorAll('[data-registration-link]').forEach(item => { item.hidden = true; });
  } catch (_) {}
};
const init = () => { updateCountdown(); updateRegistration(); };
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
setInterval(updateCountdown, 60000);
document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxur-past-auctions"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.luxur-archive').forEach(section => {
    const apiRoot = section.dataset.apiUrl.replace(/\/$/, '');
    const labels = section.dataset;
    const index = section.querySelector('[data-archive-index]');
    const catalogue = section.querySelector('[data-archive-catalogue]');
    const salesGrid = section.querySelector('[data-archive-sales]');
    const lotsGrid = section.querySelector('[data-past-lots]');
    const moreSales = section.querySelector('[data-more-sales]');
    const moreLots = section.querySelector('[data-more-lots]');
    const search = section.querySelector('[data-past-search]');
    let sales = [];
    let salesShown = 0;
    let selected;
    let offset = 0;
    const salePageSize = 9;
    const lotPageSize = 48;
    const money = value => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(value || 0);
    const escapeHtml = value => String(value ?? '').replace(/[&<>'"]/g, character => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[character]);
    const request = async path => {
      const response = await fetch(apiRoot + path, { cache: 'no-store' });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(data.error || labels.error);
      return data;
    };
    const date = value => new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'long', day: 'numeric', timeZone: 'America/New_York' }).format(new Date(value));
    const saleCard = sale => '<article class="luxur-sale"><div class="luxur-sale__image is-single" data-sale-collage="' + sale.id + '">' + (sale.cover_image ? '<img src="' + escapeHtml(sale.cover_image) + '" alt="" width="800" height="450" loading="lazy">' : '') + '</div><div class="luxur-sale__body"><p class="luxur-sale__date">' + date(sale.starts_at) + '</p><h3>' + escapeHtml(sale.title) + '</h3><p class="luxur-sale__meta">' + sale.lot_count + ' ' + labels.lots + '</p><button type="button" data-open-sale="' + sale.id + '">' + labels.viewCatalogue + '</button></div></article>';
    const loadSaleCollage = async sale => {
      const collage = salesGrid.querySelector('[data-sale-collage="' + sale.id + '"]');
      if (!collage) return;
      const data = await request('/api/past-auctions/' + sale.id + '/lots?limit=3&offset=0');
      const images = data.lots.filter(lot => lot.image_url).slice(0, 3);
      if (images.length < 2) return;
      collage.classList.remove('is-single');
      collage.innerHTML = images.map(lot => '<img src="' + escapeHtml(lot.image_url) + '" alt="' + escapeHtml(lot.title) + '" width="800" height="450" loading="lazy">').join('');
    };
    const renderMoreSales = () => {
      const next = sales.slice(salesShown, salesShown + salePageSize);
      salesGrid.insertAdjacentHTML('beforeend', next.map(saleCard).join(''));
      next.forEach(sale => loadSaleCollage(sale).catch(() => {}));
      salesShown += next.length;
      moreSales.hidden = salesShown >= sales.length;
    };
    const resultLabel = lot => Number(lot.sold_price) > 0 ? labels.soldFor + ' ' + money(lot.sold_price) : lot.status === 'sold' ? labels.sold : labels.noResult;
    const lotCard = lot => {
      const slug = lot.slug ? '_' + lot.slug : '';
      const record = 'https://www.liveauctioneers.com/item/' + encodeURIComponent(lot.source_item_id) + slug;
      return '<article class="luxur-past-lot"><div class="luxur-past-lot__image">' + (lot.image_url ? '<img src="' + escapeHtml(lot.image_url) + '" alt="' + escapeHtml(lot.title) + '" width="700" height="700" loading="lazy">' : '') + '</div><p class="luxur-past-lot__number">LOT ' + escapeHtml(lot.lot_number) + '</p><h3>' + escapeHtml(lot.title) + '</h3><p class="luxur-past-lot__estimate">' + labels.estimate + ': ' + money(lot.estimate_low) + '–' + money(lot.estimate_high) + '</p><p class="luxur-past-lot__result">' + resultLabel(lot) + '</p><a class="luxur-past-lot__record" href="' + record + '" target="_blank" rel="noopener">' + labels.viewRecord + ' ↗</a></article>';
    };
    const loadLots = async reset => {
      if (reset) { offset = 0; lotsGrid.innerHTML = '<p>' + labels.loading + '</p>'; }
      const query = encodeURIComponent(search.value.trim());
      const data = await request('/api/past-auctions/' + selected.id + '/lots?limit=' + lotPageSize + '&offset=' + offset + '&q=' + query);
      if (offset === 0) lotsGrid.innerHTML = '';
      lotsGrid.insertAdjacentHTML('beforeend', data.lots.map(lotCard).join(''));
      offset += data.lots.length;
      moreLots.hidden = offset >= data.total;
      section.querySelector('[data-past-meta]').textContent = date(selected.starts_at) + ' · ' + data.total + ' ' + labels.lots;
    };
    const openSale = async id => {
      selected = sales.find(sale => String(sale.id) === String(id));
      if (!selected) return;
      index.hidden = true;
      catalogue.hidden = false;
      section.querySelector('[data-past-title]').textContent = selected.title;
      section.querySelector('[data-past-source]').href = 'https://www.liveauctioneers.com/catalog/' + selected.source_catalog_id + '/';
      history.replaceState({}, '', location.pathname + '?past_auction=' + selected.id + '#luxur-past-auctions');
      await loadLots(true);
    };
    salesGrid.addEventListener('click', event => { const button = event.target.closest('[data-open-sale]'); if (button) openSale(button.dataset.openSale).catch(() => { lotsGrid.innerHTML = '<p>' + labels.error + '</p>'; }); });
    moreSales.addEventListener('click', renderMoreSales);
    moreLots.addEventListener('click', () => loadLots(false).catch(() => { moreLots.hidden = true; }));
    section.querySelector('[data-back-auctions]').addEventListener('click', () => { catalogue.hidden = true; index.hidden = false; history.replaceState({}, '', location.pathname + '#luxur-past-auctions'); });
    let searchTimer;
    search.addEventListener('input', () => { clearTimeout(searchTimer); searchTimer = setTimeout(() => loadLots(true).catch(() => { lotsGrid.innerHTML = '<p>' + labels.error + '</p>'; }), 280); });
    request('/api/past-auctions').then(data => { sales = data.auctions || []; salesGrid.innerHTML = ''; renderMoreSales(); const requested = new URLSearchParams(location.search).get('past_auction'); if (requested) openSale(requested); }).catch(() => { salesGrid.innerHTML = '<p>' + labels.error + '</p>'; });
  });

  } catch(e) { console.error(e); }
})();
})();
